<template>
  <div>
    <Editor
      id="tinymceId"
      :init="init"
      :disabled="disabled"
      v-model="myValue"
    ></Editor>
    <el-input
      type="text"
      maxlength="50"
      v-model="myValue"
      placeholder="请输入标题"
      style="width: 300px"
      v-show="false"
    ></el-input>
    <unique-img
      :showImg="showImg"
      @showImgEvent="showImgEvent"
      @getImg="getImg"
      v-if="showImg"
    ></unique-img>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/skins/ui/oxide/skin.css";

import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/save";
import "tinymce/plugins/help";
import "tinymce/plugins/charmap";
import "tinymce/plugins/paste";
import "tinymce/plugins/hr";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/toc";
import "tinymce/plugins/codesample";
import "tinymce/plugins/preview";

import APPService from "service/APPService";
import Server from "common/conf/Server";
export default {
  name: "platform-introduction-test",
  components: { Editor },
  props: {
    value: {
      type: String,
      default: "",
    },
    editorHeight: {
      type: Number,
      default: 750,
    },
    editorWidth: {
      type: Number,
      default: 400,
    },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    //插件
    plugins: {
      type: [String, Array],
      default: () =>
        "lists table wordcount code fullscreen help codesample toc insertdatetime  searchreplace  link charmap paste hr image",
    },
    toolbar: {
      type: [String, Array],
      default: () => [
        "bold italic underline strikethrough | forecolor backcolor |formatselect | fontsizeselect  | alignleft aligncenter alignright alignjustify | outdent indent",
        "bullist numlist toc pastetext|codesample charmap  hr insertdatetime |lists table link unlink |code searchreplace fullscreen help | image",
      ],
    },
  },
  data() {
    return {
      myValue: this.value,
      showImg: false,
      init: {
        language_url: "/static/tinymce/zh_CN.js",
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/lightgray",
        fontsize_formats:
          "0.22rem 0.24rem 0.26rem 0.28rem 0.30rem 0.34rem 0.36rem 0.38rem",
        height: this.editorHeight,
        width: this.editorWidth,
        toolbar: this.toolbar,
        plugins: this.plugins,
        save_enablewhendirty: false,
        menubar: false,
        paste_data_images: true,
        branding: false,
        // forced_root_block: "",
        content_style: "img {max-width:100%;}",
        formats: {
          bold: { selector: "p", styles: { "font-weight": "500" } },
        },
        setup: function (ed) {
          ed.on("init", function () {
            this.execCommand("fontSize", false, " 0.30rem");
          });
        },
      },
    };
  },
  watch: {
    value(val, oldVal) {
      this.myValue = val;
    },
    myValue(val, oldVal) {
      this.$emit("change", val);
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  created() {
    const that = this;
    this.init = {
      language_url: "/static/tinymce/zh_CN.js",
      language: "zh_CN",
      content_style: "img {max-width:100%;}",
      // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
      // content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
      // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide-dark`, // 暗色系
      // content_css: `${this.baseUrl}/tinymce/skins/content/dark/content.css`, // 暗色系
      width: 600,
      height: 800,
      statusbar: true, //最下方的元素路径和字数统计那一栏是否显示
      // draggable_modal: true, //模态窗口允许拖动
      elementpath: false, //隐藏底栏的元素路径
      // resize: "both", //允许拖动编辑器
      // forced_root_block: "", //去除换行出现的<p>标签
      plugins: that.plugins,
      toolbar: that.toolbar,
      setup: function (editor) {
        // 注册一个自定义的按钮
        editor.ui.registry.addButton("imgList", {
          icon: "emoji",
          onAction: function (_) {
            that.showImg = true;
            that.editor = editor;
          },
        });
      },
      branding: false,
      menubar: false,
      table_default_styles: {
        width: "100%",
        borderCollapse: "collapse",
      },
      paste_data_images: true, //图片是否可粘贴
      image_description: false,
      image_title: false, // 是否开启图片标题设置的选择，这里设置否
      // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
      // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
      images_upload_handler: (blobInfo, success, failure) => {
        if (blobInfo.blob().size / 1024 / 1024 > 2) {
          failure("上传失败，单张图片大小请控制在 2M 以内", { remove: true });
        } else {
          // 本地base64图片显示
          // const img = "data:image/jpeg;base64," + blobInfo.base64();
          // success(img);
          let params = new FormData();
          console.log(blobInfo.blob());
          params.append("picture", blobInfo.blob());
          // params.append("sourceTable", "harmonize_knowledge_article");
          //自己后台的上传接口
          APPService.uploadImg(params).then(
            (res) => {
              console.log(res);
              const imgUrl = res.contents;
              //   "上传图片接口 上传成功后返回图片地址，用于显示在富文本中";
              success(imgUrl);
            },
            (err) => {
              failure("上传失败--" + err.message);
            }
          );
        }
      },
    };
  },
  mounted() {
    tinymce.init({
      image_dimensions: false,
      mode: "specific_textareas",
      editor_encoding: "raw",
      editor_selector: "tinyMCE",
      relative_urls: false,
      convert_urls: false,
    });
  },
  methods: {
    showImgEvent(v) {
      this.showImg = v;
    },
    clear() {
      this.myValue = "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/MyEditor.vue